/* eslint-disable no-undef */
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { AUTH_TOKEN_NAME } from '../../controllers/AutenticacaoController';

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const auth = useAuth();

  if (!auth.currentUser) {
    const getToken = localStorage.getItem(AUTH_TOKEN_NAME);
    if (getToken) {
      auth.validateToken();
    } else {
      return <Navigate to={{ pathname: '/' }} />;
    }
  }
  return children;
};

export default RequireAuth;
